export default {
    assign_firmware_title: "Asignar el Firmware",
    assign_firmware_the_device_is_already_added: "El dispositivo ya está añadido",
    assign_firmware_the_hardware_version_of_the_device_mustbe_the_same: "La versión de hardware de los dispositivos debe ser la misma",
    assign_firmware_the_manufacturer_of_the_device_must_be_vidfleet: "El fabricante del dispositivo debe ser VidFleet",
    assign_firmware_no_device_found: "No se ha encontrado ningún dispositivo",
    assign_firmware_serial: "Serial",
    assign_firmware_device_name: "Nombre del dispositivo",
    assign_firmware_model: "Modelo",
    assign_firmware_label: "Firmware",
    assign_firmware_error_firmware_currently: "La versión del nuevo firmware debe ser superior a la asignada actualmente a los dispositivos",
    assign_firmware_error_firmware_different: "La versión del nuevo firmware debe ser diferente de la asignada actualmente a los dispositivos",
    assign_firmware_hardware_version: "Versión de Hardware",
    assign_firmware_the_firmware_has_been_updated: "El firmware se ha actualizado",
    assign_firmware_firmware_upgrade_not_posible: "No es posible actualizar el firmware",
    assign_firmware_outdated: "Desactualizado",
    assign_firmware_firmware_refresh_cameras: "Refrescar el firmaware de los dispositivos",
    assign_firmware_firmware_cameras_updated: "Firmware de los dispositivos actualizados",
    assign_firmware_updated: "Actualizado",
    assign_firmware_device_model: "Modelo de Dispositivo",
    assign_firmware_devices: "Dispositivos",
    assign_firmware_no_data: "No hay dispositivos que configurar",
    assign_firmware_select_firmware: "Seleccione un Firmware",
    assign_firmware_new_Firmware: "Nuevo Firmware",
    assign_firmware_all_devices: "Todos los Dispositivos",
    assign_firmware_label_all_devices: "Los cambios se aplicarán a todos los dispositivos de la cuenta",
    assign_firmware_no_firmwares: "No hay firmwares disponible para",
    assign_firmware_not_specified: "Not Specified",
}